import { ChangeDetectionStrategy, Component } from '@angular/core';

@Component({
  selector: 'us-registration-promotion-banner',
  standalone: true,
  templateUrl: './registration-promotion-banner.component.html',
  styleUrls: ['./registration-promotion-banner.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class RegistrationPromotionBannerComponent {}
